'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var baseStyle = {
  borderColor: 'gray.300',
  borderStyle: 'solid'
};
var Divider = {
  baseStyle: baseStyle
};
exports["default"] = Divider;